import React, { useState, useEffect,useRef } from 'react';
import { Box, Typography, Button, Paper, CircularProgress, Snackbar, Alert } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ReportFilterModal from './VehicleViewTopBar';
import axios from 'axios';

const VideoStreamComponent = ({ streamUrl }) => {
    const imgRef = useRef(null);
    
    useEffect(() => {
      const img = imgRef.current;
      if (!img || !streamUrl) return;
      
      // Set error handler before setting src
      img.onerror = (e) => {
        console.error("Stream error:", e);
        // Wait before retrying
        setTimeout(() => {
          if (imgRef.current) {
            imgRef.current.src = streamUrl;
          }
        }, 2000);
      };
      
      // Set src once and let the MJPEG stream update continuously
      img.src = streamUrl;
      
      return () => {
        img.onerror = null;
        img.src = '';
      };
    }, [streamUrl]);
    
    return (
      <img 
        ref={imgRef}
        alt="RTSP Stream" 
        style={{ 
          width: '100%', 
          height: '100%',
          objectFit: 'contain'
        }}
      />
    );
  };
  export default VideoStreamComponent;